<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import type { ImageSize } from './Utils';
    import values from 'lodash/values';
    import find from 'lodash/find';
    import difference from 'lodash/difference';
    import includes from 'lodash/includes';
    import uniq from 'lodash/uniq';
    import LinkPreview from './LinkPreview.svelte';
    import { safe } from '$lib/utils/string.js';

    export let links: string[];
    export let linkClass: string = '';
    export let maxSize: ImageSize = null;

    const dispatch = createEventDispatcher<{
        ids: number[];
    }>();

    let removedIds: number[] = [];
    let mapping: { [key: string]: number } = {};
    let currentLink: string | null = null;
    let oneLinkToShow: string | null = null;

    function findLinkToShow(
        _mapping: typeof mapping,
        _removedIds: typeof removedIds,
        _links: typeof links,
    ): string | null {
        let ids = difference(values(mapping), removedIds);
        let link = find(links, (link) => {
            return mapping[link] == null || ids.includes(mapping[link]!);
        });
        return link || currentLink;
    }

    $: if (oneLinkToShow != null && mapping[oneLinkToShow] != null) {
        dispatch('ids', [mapping[oneLinkToShow]!]);
        currentLink = oneLinkToShow;
    }
    $: if (oneLinkToShow == null) {
        dispatch('ids', []);
    }

    $: oneLinkToShow = findLinkToShow(mapping, removedIds, links);

    function getList(
        _links: string[],
        _currentLink: string | null,
        _oneLinkToShow: string | null,
        _mapping: { [key: string]: number },
        _removedIds: number[],
    ): string[] {
        if (oneLinkToShow !== null && !includes(links, oneLinkToShow))
            return [oneLinkToShow, ...links];
        return [...links];
    }

    $: list = getList(links, currentLink, oneLinkToShow, mapping, removedIds);
</script>

{#key safe`${removedIds.join(',')}-${oneLinkToShow ?? ''}-${currentLink ?? ''}`}
    <div class={'space-y-2'}>
        {#each list as link, index (index)}
            <LinkPreview
                {linkClass}
                url={link}
                {maxSize}
                on:remove={(event) => {
                    let id = event.detail;
                    if (link === currentLink) currentLink = null;
                    removedIds = uniq([...removedIds, id]);
                }}
                show={(id) => {
                    return !removedIds.includes(id) && link === oneLinkToShow;
                }}
                on:load={(event) => {
                    const { url, id } = event.detail;
                    mapping = { ...mapping, [url]: id };
                }}
            />
        {/each}
    </div>
{/key}
